"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ChartDimensionState_1 = require("../../entity/ChartDimensionState");
var DimensionValueState_1 = require("../../entity/DimensionValueState");
var useDimension_1 = require("../../hooks/useDimension");
var core_1 = require("@material-ui/core");
var styled_components_1 = require("styled-components");
var dimensionArrayEquals_1 = require("../../utility/dimensionArrayEquals");
var useMounted_1 = require("../../hooks/useMounted");
var BreakdownSelector = function (_a) {
    var chartData = _a.chartData, updateChart = _a.updateChart, changeChartDimension = _a.changeChartDimension, datasetsValue = _a.datasetsValue;
    var _b = (0, useDimension_1["default"])(), chartDimensionKeyState = _b[0], dispatchChartDimensionKeyState = _b[1];
    var _c = (0, react_1.useState)(true), isInit = _c[0], setIsInit = _c[1];
    var _d = (0, react_1.useState)(chartDimensionKeyState), previousChartDimensionKeyState = _d[0], setPreviousChartDimensionKeyState = _d[1];
    var isMounted = (0, useMounted_1["default"])();
    (0, react_1.useEffect)(function () {
        if (datasetsValue === 'all' && isMounted && updateChart) {
            handleChangeRadioToAll();
            updateChart();
        }
    }, [datasetsValue]);
    var onCloseSelector = function () {
        if (updateChart && !(0, dimensionArrayEquals_1["default"])(chartDimensionKeyState, previousChartDimensionKeyState)) {
            updateChart();
        }
        setPreviousChartDimensionKeyState(chartDimensionKeyState);
    };
    var onClickAllSelection = function (dimensionIndex, isSelectedAll) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL_SELECT',
                dimensionIndex: dimensionIndex,
                changeDimension: changeChartDimension,
                isSelectedAll: isSelectedAll
            });
        }
    };
    var handleBreakdownClearButtonClick = function (dimensionIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'CLEAR',
                dimensionIndex: dimensionIndex,
                changeDimension: changeChartDimension
            });
        }
    };
    var handleChartFilterClick = function (dimensionIndex, filterIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'FILTER',
                dimensionIndex: dimensionIndex,
                filterIndex: filterIndex,
                changeDimension: changeChartDimension
            });
        }
    };
    var handleChangeRadioToAll = function () {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL_INIT',
                changeDimension: changeChartDimension
            });
        }
    };
    var handleChangeBreakdownRadio = function (dimensionIndex, filterIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL',
                dimensionIndex: dimensionIndex,
                filterIndex: filterIndex,
                changeDimension: changeChartDimension
            });
        }
    };
    var chartDimensions = chartData
        ? Array.isArray(chartData)
            ? chartData[0].breakdowns
                ? chartData[0].breakdowns
                : undefined
            : chartData.breakdowns
                ? chartData.breakdowns
                : undefined
        : undefined;
    if (chartDimensions && isInit) {
        var initialChartDimensionState = chartDimensions
            .filter(function (dimension) { return dimension.display; })
            .map(function (dimension) {
            var filterState = dimension.values
                ? dimension.values.map(function (filter) {
                    return new DimensionValueState_1["default"]({ value: filter, isSelected: false });
                })
                : [];
            return new ChartDimensionState_1["default"]({
                breakdown: new DimensionValueState_1["default"]({ value: dimension.key.label, isSelected: false }),
                filter: filterState
            });
        });
        setPreviousChartDimensionKeyState(initialChartDimensionState);
        dispatchChartDimensionKeyState.setDimensionKeyState({
            type: 'INIT',
            initState: initialChartDimensionState
        });
        setIsInit(false);
    }
    return ((0, jsx_runtime_1.jsx)(BreakdownContainer, { children: chartDimensionKeyState.length > 0
            ? chartDimensionKeyState.map(function (dimensionKeyState, dimensionIndex) {
                return ((0, jsx_runtime_1.jsx)(Breakdowns, { children: (0, jsx_runtime_1.jsx)(core_1.FormControl, { children: (0, jsx_runtime_1.jsxs)(core_1.Select, __assign({ value: new Array(dimensionKeyState.breakdown.value), renderValue: function () { return dimensionKeyState.breakdown.value; }, multiple: true, onClose: onCloseSelector }, { children: [datasetsValue !== 'all' ? ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ onClick: function () {
                                        return onClickAllSelection(dimensionIndex, !dimensionKeyState.filter.some(function (filter) { return !filter.isSelected; }));
                                    } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Checkbox, { color: "primary", checked: !dimensionKeyState.filter.some(function (filter) { return !filter.isSelected; }) }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: "\u5168\u9078\u629E" })] }))) : ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ onClick: function () { return handleBreakdownClearButtonClick(dimensionIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Radio, { checked: !dimensionKeyState.filter.some(function (filter) { return filter.isSelected; }), color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: "\u672A\u9078\u629E" })] }))), dimensionKeyState.filter
                                    ? dimensionKeyState.filter.map(function (filter, filterIndex) {
                                        return datasetsValue == 'all' ? ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ value: filter.value, onClick: function () { return handleChangeBreakdownRadio(dimensionIndex, filterIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Radio, { checked: filter.isSelected, color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: filter.value })] }), filter.value)) : ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ value: filter.value, onClick: function () { return handleChartFilterClick(dimensionIndex, filterIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Checkbox, { checked: filter.isSelected, color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: filter.value })] }), filter.value));
                                    })
                                    : null] })) }) }, dimensionKeyState.breakdown.value));
            })
            : null }));
};
var BreakdownContainer = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Breakdowns = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 8px;\n"], ["\n  margin: 8px;\n"])));
exports["default"] = BreakdownSelector;
var templateObject_1, templateObject_2;
